import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

// Cut K3b (2026-09-06, BDR-034): 'recert_campaign_review' und der
// source_type 'recert_campaign' sind entfernt, sie benannten
// Rezertifizierung Generation A. Beide Unions bleiben unvollstaendig:
// das Backend liefert mehr Task-Typen als hier stehen, das Nachziehen
// gehoert Cut T14 und nicht diesem Cut.
export type TaskType = 'promotion_approval';
export type TaskUrgency = 'normal' | 'soon' | 'overdue';

export interface Task {
  id: string;
  type: TaskType;
  title: string;
  subtitle: string;
  urgency: TaskUrgency;
  created_at: string;
  deadline?: string;
  action_url: string;
  source_type: 'promotion';
  source_id: string;
  count?: number;
  // 0.57.31: Historie-Felder. Nur gesetzt für ?status=closed.
  outcome?: string;       // approved | rejected | revoked | expired | accepted | declined
  decided_at?: string;
  decided_by?: string;
}

@Injectable({ providedIn: 'root' })
export class TasksService {
  private http = inject(HttpClient);
  private base = `${environment.apiBaseUrl}/v1/tasks`;

  list(status?: 'open' | 'closed'): Observable<{ items: Task[]; total: number }> {
    const url = status ? `${this.base}?status=${status}` : this.base;
    return this.http.get<{ items: Task[]; total: number }>(url);
  }
}
